import { render, staticRenderFns } from "./Footmin.vue?vue&type=template&id=5b765840&"
var script = {}
import style0 from "./Footmin.vue?vue&type=style&index=0&id=5b765840&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports